import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Location } from '@angular/common'

@Component({
  selector: 'app-admin-management',
  templateUrl: './admin-management.component.html',
  styleUrls: ['./admin-management.component.scss']
})

export class AdminManagementComponent implements AfterViewInit {

  @ViewChild("table", { static: false }) table: TableComponent;
  private uuid;
  public data: any = {};
  public is_mario:boolean = false;
  public user_permission:any = {};
  constructor(private route: ActivatedRoute, private location: Location, private http: HttpService) { 
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['user_company_uuid']));
    this.user_permission = this.http.getSelecetdCompanyDetail();

    uuid.subscribe(val => {
      if(val) {
        this.uuid = val;
        this.init(this.uuid)
      } else {
        this.location.back();
      }
    })

    let access:any = this.http.getAccess();

    if(access.is_mario) {
      this.is_mario = access.is_mario == "1" ? true : false;
    }
  }

  ngAfterViewInit(): void {
  }

  async init(uuid) {
    this.data = await this.http.post("/admin/user/get/detail/uuid", {uuid});
  }

  async update() {
    await this.http.post("/admin/user/permission/update", this.data);
    this.location.back();
  }

}
